import { Controller } from "stimulus";

export default class extends Controller {
  
  static targets = [
    "form", "searchButton", "searchResults", "noResults", "container", "hiddenAgencySearch"
  ];

  connect() {

    this.searchButtonTarget.addEventListener("click", e =>
    {
      e.preventDefault();
      
      let div = document.createElement("div");
      div.classList.add("circle-loader");

      this.searchButtonTarget.parentElement.appendChild(div);
      this.searchButtonTarget.classList.add("hidden");

      let data = new FormData(this.formTarget);

      fetch(window.App.prefixedUrl("/search/agencies"),
      {
        method: "post",
        body: data
      })
      .then(data => data.json())
      .then(data =>
      {
        this.hiddenAgencySearchTarget.value = null;

        if(data.length == 0)
        {
          this.containerTarget.classList.add("hidden");
          this.noResultsTarget.classList.remove("hidden");
          this.searchResultsTarget.classList.remove("hidden");
        }
        else
        {
          let elements = data.map((row) =>
          {
            let item = document.createElement("div");
            item.innerHTML = `<span>${row.agency_name}</span><span>${row.phone}</span>`;
            item.dataset["agency_num"] = row.agency_num;
            item.classList.add("result-item");

            return item;
          });

          elements.forEach(item =>
          {
            item.addEventListener("click", e =>
            {
              elements.forEach(el => el.classList.remove("selected"));

              item.classList.add("selected");

              this.hiddenAgencySearchTarget.value = item.dataset["agency_num"];
            })
          })

          this.containerTarget.innerHTML = "";
          this.containerTarget.append(...elements);

          this.noResultsTarget.classList.add("hidden");
          this.containerTarget.classList.remove("hidden");
          this.searchResultsTarget.classList.remove("hidden");
        }
      })
      .finally(() =>
      {
        this.searchButtonTarget.parentElement.lastElementChild.remove();
        this.searchButtonTarget.classList.remove("hidden");
      })
      .catch(e =>
      {
        let toastEvent = new CustomEvent("show-toast", { detail: "An error occurred:\n" + e.message })
        window.dispatchEvent(toastEvent);
      })
    })
  }


}